/**
 * @generated SignedSource<<4f9c95323217868d1d5dc8395a327f5f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type sourcesPage_SyncNowMutation$variables = {
  mode?: string | null | undefined;
};
export type sourcesPage_SyncNowMutation$data = {
  readonly qboSyncStart: {
    readonly enqueued: boolean;
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
  } | null | undefined;
};
export type sourcesPage_SyncNowMutation = {
  response: sourcesPage_SyncNowMutation$data;
  variables: sourcesPage_SyncNowMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "mode"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "mode",
    "variableName": "mode"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "enqueued",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "sourcesPage_SyncNowMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "QboSyncStartMutationPayload",
        "kind": "LinkedField",
        "name": "qboSyncStart",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "sourcesPage_SyncNowMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "QboSyncStartMutationPayload",
        "kind": "LinkedField",
        "name": "qboSyncStart",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "2bb044b34cd7fe48582dfaed94f302dd",
    "id": null,
    "metadata": {},
    "name": "sourcesPage_SyncNowMutation",
    "operationKind": "mutation",
    "text": "mutation sourcesPage_SyncNowMutation(\n  $mode: String\n) {\n  qboSyncStart(mode: $mode) {\n    enqueued\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "99b0946f3e5c07c9a0d282e151ac30be";

export default node;
